import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  columns,
  fetchData, // (page, month, year, search)
  paginationData, // { data, page, limit, totalClients }
  totalRevenue,
  totalTrips,
}) {
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const handleRowsPerPageChange = (newLimit, page) => {
    fetchData(1, month || undefined, year || undefined, search, newLimit);
  };

  const pageSize = paginationData.limit || 10;

  /* 🔹 INITIAL LOAD */
  useEffect(() => {
    fetchData(1, undefined, undefined, "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* 🔹 APPLY FILTERS (MONTH/YEAR) */
  const applyFilters = () => {
    setShowFilterModal(false);
    fetchData(1, month || undefined, year || undefined, search);
  };

  /* 🔹 REMOVE FILTERS */
  const removeFilters = () => {
    setMonth("");
    setYear("");
    setSearch("");
    setShowFilterModal(false);
    fetchData(1, undefined, undefined, "");
  };

  /* 🔹 PAGE CHANGE */
  const handlePageChange = (page) => {
    fetchData(page, month || undefined, year || undefined, search);
  };

  /* 🔹 UPDATE TABLE DATA */
  useEffect(() => {
    setFilteredData(paginationData.data || []);
  }, [paginationData.data]);

  return (
    <div className="table-responsive">
      {/* 🔍 SEARCH + FILTER */}
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search by Client Name"
            value={search}
            onChange={(e) => {
              const value = e.target.value;
              setSearch(value);
              fetchData(1, month || undefined, year || undefined, value);
            }}
          />
        </div>

        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
          <button className="btn btn-success me-2">
            Revenue : {totalRevenue.toLocaleString()} /-
          </button>
          <button className="btn btn-success me-2">
            Total Trips : {totalTrips.toLocaleString()} /-
          </button>
        </div>
      </div>

      {/* 📊 DATA TABLE */}
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        paginationServer
        paginationPerPage={pageSize}
        // paginationRowsPerPageOptions={[pageSize]}
        paginationRowsPerPageOptions={[5, 10, 15, 20]} // ✅ USER OPTIONS
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationTotalRows={paginationData.totalClients || 0}
        onChangePage={handlePageChange}
        fixedHeader
        highlightOnHover
        responsive
      />

      {/* 🔘 FILTER MODAL */}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        month={month}
        setMonth={setMonth}
        year={year}
        setYear={setYear}
      />
    </div>
  );
}
